import useGetUserLocation from "@/common/hooks/useGetUserLocation";
import BaseMap from "@/components/Map/BaseMap";

export default function MapView({
  addressAData,
  addressBData,
  height,
}: {
  addressAData: any;
  addressBData?: any;
  height?: string;
}) {
  const userPosition = useGetUserLocation()
  const pickedMarkers =
    typeof addressBData === "undefined"
      ? [
          {
            fullAddress: addressAData.fullAddress,
            position: addressAData.position,
          },
        ]
      : [
          {
            fullAddress: addressAData.fullAddress,
            position: addressAData.position,
          },
          {
            fullAddress: addressBData.fullAddress,
            position: addressBData.position,
          },
        ];
  return (
    <div className="h-full w-full rounded-lg overflow-hidden">
      <BaseMap
        center={addressAData.position ||userPosition }
        isActions={true}
        style={{
          width: "100%",
          height: height ? height : "236px",
          borderRadius: "16px",
        }}
        markers={pickedMarkers.filter(el =>
          el?.position?.lat != null &&
          el?.position?.lng != null
        )}
      />
    </div>
  );
}
